import right from '../../../public/right.svg';
import styles from '../../styles/components/lists/ItemsList.module.scss';
import Image from 'next/legacy/image';

interface Props {
  items: string[];
  onClick: (item: string) => void;
}

const ItemsList = (props: Props) => {
  return (
    <section className={styles.wrapper}>
      <ul>
        {props.items.map((item, i) => (
          <li key={i}>
            <a onClick={() => props.onClick(item)}>
              <span>{item}</span>
              <Image src={right} width="18" height="18" alt="" />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export { ItemsList };
